import { combineReducers } from "redux";
import { listReducer } from "./list";
import { editProjectReducer } from "./editProject";
import { addProjectReducer } from "./addProject";

const reducer = combineReducers({
    list: listReducer,
    editProject: editProjectReducer,
    addProject: addProjectReducer,
})

export default reducer;
